var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "whatsappcontactlist" } },
    [
      _c(
        "div",
        [
          _c("b-button", { staticClass: "m-2", on: { click: _vm.refresh } }, [
            _vm._v("Refresh"),
          ]),
          _vm._v(" "),
          _c("a-input-search", {
            staticClass: "search-input",
            attrs: { placeholder: _vm.$t("message.startFilter") },
            on: {
              input: function ($event) {
                return _vm.onSearch($event.target.value)
              },
            },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-table", {
        key: "vtable-" + _vm.renderCount,
        staticClass: "custom-table",
        attrs: {
          columns: _vm.cols,
          dataSource: _vm.getOnlyPersonelContacts,
          pagination: _vm.pagination,
          loading: _vm.loading,
          locale: {
            emptyText: _vm.$t("message.noContactFound"),
          },
          rowKey: "id",
          size: "small",
        },
        on: { change: _vm.handleTableChange },
        scopedSlots: _vm._u([
          {
            key: "avatarSlot",
            fn: function (data, item) {
              return _c(
                "div",
                { staticClass: "p-1" },
                [
                  _c(
                    "a-avatar",
                    {
                      staticStyle: {
                        "background-color": "#3899ff",
                        "border-radius": "7px !important",
                      },
                      attrs: {
                        size: 30,
                        shape: "square",
                        username: item.name,
                        src: _vm.$_.get(item, "profilePicThumbObj.eurl"),
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(item.name.substr(0, 1).toLocaleUpperCase()) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              )
            },
          },
          {
            key: "action",
            fn: function (data, item) {
              return _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "d-flex justify-content-end",
                    staticStyle: { "margin-right": "-10px !important" },
                  },
                  [
                    _c(
                      "md-button",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                              theme: _vm.isDarkMode ? "light-border" : "google",
                            },
                            expression:
                              "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                          },
                        ],
                        attrs: {
                          id: "joinChat",
                          content: _vm.$t("wp.startChatWp"),
                          "data-v-step": "16",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.startChat(item.id)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("wp.startChatWp")) +
                            "\n                    "
                        ),
                        _c(
                          "md-icon",
                          {
                            staticStyle: {
                              color: "#06e576",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v(" whatsapp ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }